import { render, staticRenderFns } from "./standalone-checkout.vue?vue&type=template&id=391b9d55&scoped=true"
import script from "./standalone-checkout.vue?vue&type=script&lang=js"
export * from "./standalone-checkout.vue?vue&type=script&lang=js"
import style0 from "./standalone-checkout.vue?vue&type=style&index=0&id=391b9d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b9d55",
  null
  
)

export default component.exports